// extracted by mini-css-extract-plugin
export default {"amenity":"styles_amenity__SrW06","tickCircle":"styles_tickCircle__4H+Xr"};